export const aciWaterPark = {
    iconName: 'water-park',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M7.375 19.673a.5.5 0 01.688 0 4.066 4.066 0 005.59 0 .5.5 0 01.688 0 4.066 4.066 0 004.829.57.5.5 0 01.5.865 5.065 5.065 0 01-5.672-.412 5.066 5.066 0 01-6.278 0 5.048 5.048 0 01-3.14 1.09.5.5 0 010-1 4.048 4.048 0 002.795-1.113zM12.25 6.762a.5.5 0 01.5-.5h5.925a.5.5 0 01.5.5v9.874a.993.993 0 01-.994.994h-4.937a.994.994 0 01-.994-.994V6.761zm1 .5v9.367h4.925V7.263H13.25z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M15.712 3.22l-2.546 3.82a.5.5 0 01-.832-.555l2.552-3.828a.994.994 0 011.653 0l2.552 3.828a.5.5 0 11-.832.554l-2.547-3.82zM6.792 12.233l5.54-4.272.61.792-5.557 4.286-.01.007a4.58 4.58 0 01-.736.408c-.277.122-.636.248-.965.248-.349 0-.46.11-.502.166a.581.581 0 00-.092.343v1.873c0 .254.09.357.172.417a.84.84 0 00.443.129c.573.024.81.023 1.116-.14.45-.24 1.465-.98 2.616-1.859.723-.55 1.475-1.138 2.143-1.658l1.042-.81.611.792c-.298.23-.649.503-1.03.8-.671.523-1.434 1.118-2.16 1.671-1.122.857-2.213 1.66-2.753 1.947-.566.3-1.055.28-1.598.257h-.029c-.278-.012-.66-.083-.986-.318-.353-.255-.587-.665-.587-1.228V14.21c0-.238.045-.617.293-.945.268-.355.704-.564 1.301-.564.113 0 .314-.054.56-.163.229-.1.438-.223.558-.306z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
